"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[285],{

/***/ 91185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ createBitlinks; }
/* harmony export */ });
/* unused harmony export postBitlyShortLink */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79825);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var BITLY_HEADER = {
    headers: {
        Authorization: "Bearer ".concat("28cf2ece2897e77f193f4f4b2638227746305913"),
        "Content-Type": "application/json"
    }
};
var createBitlinks = function() {
    var _ref = _asyncToGenerator(function(param) {
        var longUrl, title, separator, uniqueUrl, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    longUrl = param.longUrl, title = param.title;
                    separator = longUrl.includes("?") ? "&" : "?";
                    uniqueUrl = "".concat(longUrl).concat(separator, "_t=").concat(Date.now());
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("https://api-ssl.bitly.com/v4/bitlinks", _objectSpreadProps(_objectSpread({
                            long_url: uniqueUrl,
                            domain: "share.chatie.me",
                            group_guid: "Bjca3uCqoip"
                        }, title && {
                            title: title
                        }), {
                            force_new_link: true
                        }), BITLY_HEADER)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ]; // data.link 가 short link
            }
        });
    });
    return function createBitlinks(_) {
        return _ref.apply(this, arguments);
    };
}();
var postBitlyShortLink = function() {
    var _ref = _asyncToGenerator(function(param) {
        var longUrl, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    longUrl = param.longUrl;
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("https://api-ssl.bitly.com/v4/shorten", {
                            long_url: longUrl,
                            domain: "share.chatie.me",
                            group_guid: "Bjca3uCqoip"
                        }, BITLY_HEADER)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postBitlyShortLink(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 30285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ modal_ShareModal; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./stores/useLoadingStore.ts
var useLoadingStore = __webpack_require__(70182);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./api/bitly.ts
var bitly = __webpack_require__(91185);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(39854);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
// EXTERNAL MODULE: ./utils/analytics.ts
var analytics = __webpack_require__(3263);
// EXTERNAL MODULE: ./utils/hook.ts
var hook = __webpack_require__(97033);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
;// CONCATENATED MODULE: ./public/images/share/facebook.png
/* harmony default export */ var facebook = ({"src":"https://mn.chatie.me/assets/8e774a4b1499c8356f38cb4b0007043a0c52e9e6/_next/static/media/facebook.eba5ad8e.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEUzTZIyTZIzTZIjQIpMaXEuSI++xtyksM+AkLs0TpLV2+kyTJExTJFMY6Bjd6vMstQJAAAADHRSTlP0KLP6APf+/v6z/rPi70e7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImR3KSQ6AMBDEwJ41CRj+/1w03Cy5lOaq21ImeJDJid2FS3A1aKJXoFlrBz74/XHaqTqWHzVEAYINLQ2eAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/share/kakao.png
/* harmony default export */ var kakao = ({"src":"https://mn.chatie.me/assets/8e774a4b1499c8356f38cb4b0007043a0c52e9e6/_next/static/media/kakao.d467e012.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAASFBMVEX/6wBvWRn44gEuGCVMaXFKNSBfSRz/8gD/6gCTfhP75AD75AD54gE5IyP03QH/8AD/8ADWwAf44QB3Yhjp0wPHsQnlzgSslQ7U0nE0AAAAEHRSTlPz/Cj+APz+9rP8sygo/iizjACHCwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEFJREFUCJkFwQcCgCAMALEDCi1DLeD4/09NkGGqdgoDn3MRsRVSyvNCv1J32Io+OZRcleb1KHUZkfd2pyPRoHX5AVRsAkhT5IjnAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/share/url.png
/* harmony default export */ var share_url = ({"src":"https://mn.chatie.me/assets/8e774a4b1499c8356f38cb4b0007043a0c52e9e6/_next/static/media/url.a7af42e9.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEW6urrPz8+7u7u8vLxMaXG7u7va2tq6urq6urrFxcVQBG0vAAAACHRSTlP1/bMoACj+s4YjL9UAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA0SURBVAiZHcbBDQAwCAOxS4A27L9wpfplegy3miHRUjhIiiF7zgaI9ONIIqbIJgxdFzz9ACMBAPuliH+jAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./components/common/Image.tsx
var Image = __webpack_require__(85496);
// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(59585);
;// CONCATENATED MODULE: ./components/modal/ShareModal.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 240px;\n  margin: 0 auto;\n\n  button {\n    width: 60px;\n  }\n\n  button p {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        "px;\n  text-align: center;\n  margin-bottom: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















var wrapCSS = (0,emotion_react_browser_esm.css)(_templateObject(), dist_esm/* Spacing.xsmall */.Ki.xsmall);
var descriptionCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject1(), theme.var.gray500, dist_esm/* FontSizes.small */.TS.small, dist_esm/* Spacing.small */.Ki.small);
};
var ShareModal = function(_param) {
    var description = _param.description, url = _param.url, title = _param.title, summary = _param.summary, episodeId = _param.episodeId, storyId = _param.storyId, shareType = _param.shareType, _imageUrl = _param.imageUrl, imageUrl = _imageUrl === void 0 ? "https://chatie.me/og_image.png" : _imageUrl, props = _objectWithoutProperties(_param, [
        "description",
        "url",
        "title",
        "summary",
        "episodeId",
        "storyId",
        "shareType",
        "imageUrl"
    ]);
    var t = (0,esm/* useTranslation */.$G)().t;
    var web = (0,webview/* useWebView */.B9)().web;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var platform = (0,global/* useGlobalContext */.bN)().platform;
    var ref = (0,hook/* useMe */.Pi)(), me = ref.data;
    var ref1 = (0,react.useState)({}), shortLinks = ref1[0], setShortLinks = ref1[1];
    var setLoading = (0,useLoadingStore/* useLoadingStore */.R)().setLoading;
    var socials = [
        {
            image: kakao,
            label: t("카카오"),
            type: "kakao"
        },
        {
            image: facebook,
            label: t("페이스북"),
            type: "facebook"
        },
        {
            image: share_url,
            label: t("링크"),
            type: "url"
        }, 
    ];
    var makeShortLink = function() {
        var _ref = _asyncToGenerator(function(type, url) {
            var isExternal, destUrlParams, destUrl, res;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isExternal = /^https?/.test(url);
                        if (isExternal) {
                            return [
                                2,
                                Promise.resolve(url)
                            ];
                        }
                        destUrlParams = (0,misc/* toQueryString */.UK)({
                            shareType: platform === constants/* Platform.web */.t4.web ? constants/* ShareType.web */.yw.web : constants/* ShareType.app */.yw.app,
                            uid: me === null || me === void 0 ? void 0 : me.id,
                            share: true,
                            source: type
                        });
                        destUrl = "".concat("https://mn.chatie.me").concat(url).concat(destUrlParams);
                        return [
                            4,
                            (0,bitly/* createBitlinks */.l)({
                                longUrl: destUrl,
                                title: title
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res.link
                        ];
                }
            });
        });
        return function makeShortLink(type, url) {
            return _ref.apply(this, arguments);
        };
    }();
    var shareViaKakao = function(linkUrl) {
        var ref, ref1, ref2;
        var _NEXT_PUBLIC_KAKAO_APP_ID;
        var kakaoId = (_NEXT_PUBLIC_KAKAO_APP_ID = "10126019c402311fc09b71f99a9112bd") !== null && _NEXT_PUBLIC_KAKAO_APP_ID !== void 0 ? _NEXT_PUBLIC_KAKAO_APP_ID : "";
        if (!(window === null || window === void 0 ? void 0 : (ref = window.Kakao) === null || ref === void 0 ? void 0 : ref.isInitialized())) {
            var ref3;
            window === null || window === void 0 ? void 0 : (ref3 = window.Kakao) === null || ref3 === void 0 ? void 0 : ref3.init(kakaoId);
        }
        window === null || window === void 0 ? void 0 : (ref1 = window.Kakao) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Share) === null || ref2 === void 0 ? void 0 : ref2.sendDefault({
            objectType: "feed",
            content: {
                title: title,
                description: summary,
                imageUrl: imageUrl,
                link: {
                    mobileWebUrl: linkUrl,
                    webUrl: linkUrl
                }
            },
            buttons: [
                {
                    title: "자세히 보기",
                    link: {
                        mobileWebUrl: linkUrl,
                        webUrl: linkUrl
                    }
                }, 
            ]
        });
    };
    var handleShare = function(type) {
        if (url === undefined || title === undefined || summary === undefined) {
            return;
        }
        if (shortLinks[type]) {
            if (type === "kakao") {
                return shareViaKakao(shortLinks[type]);
            }
            return web.share(type, shortLinks[type], title, summary, imageUrl);
        }
        setLoading(true);
        makeShortLink(type, url).then(function(shortLink) {
            setShortLinks(function(prev) {
                return _objectSpreadProps(_objectSpread({}, prev), _defineProperty({}, type, shortLink));
            });
            firebase.logEvent("share_click", {
                type: shareType,
                url: url,
                source: type,
                storyId: storyId,
                episodeId: episodeId
            });
            if (type === "kakao") {
                shareViaKakao(shortLink);
            } else {
                web.share(type, shortLink, title, summary, imageUrl);
            }
        }).catch(function() {
            alert(t("공유 링크 생성을 하지 못하였습니다. 잠시 후 다시 시도해 주세요."));
        }).finally(function() {
            return setLoading(false);
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* default */.ZP, _objectSpreadProps(_objectSpread({}, props), {
        title: t("공유하기"),
        children: [
            description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                css: descriptionCSS,
                className: "multiline",
                children: description
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: wrapCSS,
                children: socials.map(function(social) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("button", {
                        onClick: function() {
                            return handleShare(social.type);
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Image/* default */.Z, {
                                src: social.image,
                                alt: social.label,
                                width: 36,
                                height: 36
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                children: social.label
                            })
                        ]
                    }, "share-".concat(social.type));
                })
            })
        ]
    }));
};
/* harmony default export */ var modal_ShareModal = (ShareModal);


/***/ }),

/***/ 70182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useLoadingStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88766);

var useLoadingStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)(function(set) {
    return {
        isLoading: false,
        setLoading: function(isLoading) {
            set({
                isLoading: isLoading
            });
        }
    };
});


/***/ })

}]);